<template>
  <section>
      <v-layout wrap>
        <v-flex md9>
          <v-card>
            <v-card-text class="conversation-container" id="conversation">
              <div v-for="(mensaje, idx) in mensajes" :key="idx" v-if="conectado && mensaje.id_caso == id_caso">
                <span v-if="mensaje.direccion == 'AVISO'" class="aviso">
                  <span class="aviso-message" v-html="mensaje.contenido">{{mensaje.contenido}}</span>
                </span>
                <div v-if="mensaje.direccion == 'AVISO' && mensaje.estado === 'COMPLETADO' ">
                  <span class="aviso hidden">
                    <span class="aviso-message">{{mensaje.contenido}}</span>
                  </span>
                </div>
                <div v-if="mensaje.direccion != 'AVISO'" v-bind:class="{'message':true, 'sent':(mensaje.direccion === 'SALIDA')}">
                  <!-- <span v-if="mensaje.tipo_contenido == 'texto'" style="white-space:pre-wrap;overflow-wrap:break-word;" v-html="parsearContenido(mensaje.contenido)"></span> -->
                  <span v-if="mensaje.tipo_contenido == 'texto'" style="white-space:pre-wrap;">{{ mensaje.contenido }}</span>
                  <span v-if="mensaje.tipo_contenido == 'email'">
                    <span v-if="mensaje.extras && mensaje.extras.asunto"><strong>{{mensaje.extras.asunto}}</strong><br></span>
                    <span v-if="mensaje.extras && mensaje.extras.remitente">De: {{mensaje.extras.remitente}}<br></span>
                    <span v-html="mensaje.contenido"></span>
                    <span v-if="mensaje.extras && mensaje.extras.adjuntos && mensaje.extras.adjuntos.length > 0"><hr/>Adjuntos</span>
                    <div v-if="mensaje.extras && mensaje.extras.adjuntos && mensaje.extras.adjuntos.length > 0">
                      <span v-for="(adjunto, ax) in mensaje.extras.adjuntos" :key="ax" class="message-chip">{{adjunto.nombre}}</span>
                      <file-viewer :caso="mensaje.id_caso" :msg_id="mensaje.msg_id" :extras="{}" file="" mime="application/zip"></file-viewer>
                    </div>
                  </span>

                  <span v-if="mensaje.extras" class="nombre-archivo">
                    <span v-if="mensaje.extras.nombre">{{mensaje.extras.nombre}}</span><span v-if="mensaje.extras.tamanio">{{mensaje.extras.tamanio}}</span>
                  </span>
                  <span v-if="mensaje.tipo_contenido == 'imagen'"><imagen-viewer :caso="mensaje.id_caso" :msg_id="mensaje.msg_id" :extras="mensaje.extras" :file="mensaje.contenido" :mime="mensaje.mime_type"></imagen-viewer></span>
                  <audio-player v-if="mensaje.tipo_contenido == 'audio'" :caso="mensaje.id_caso" :msg_id="mensaje.msg_id" :extras="mensaje.extras" :file="mensaje.contenido" :mime="mensaje.mime_type" :muteButton="true" :downloadButton="true"></audio-player>
                  <video-player v-if="mensaje.tipo_contenido == 'video'" :caso="mensaje.id_caso" :msg_id="mensaje.msg_id" :extras="mensaje.extras" :file="mensaje.contenido" :mime="mensaje.mime_type" :muteButton="true" :downloadButton="true" :fullscreenButton="true"></video-player>
                  <file-viewer v-if="mensaje.tipo_contenido == 'archivo'" :caso="mensaje.id_caso" :msg_id="mensaje.msg_id" :extras="mensaje.extras" :file="mensaje.contenido" :mime="mensaje.mime_type"></file-viewer>
                  <span class="metadata">
                    <span class="time">{{formato(mensaje)}}&nbsp;</span>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <img v-on="on" :src="imagenCanal(mensaje['canal_entrada.clasificacion'])" class="icono-canal" align="right"/>
                      </template>
                      <!--span class="tick" v-if="mensaje.direccion == 'SALIDA'"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" id="msg-dblcheck-ack" x="2063" y="2076"><path d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.88a.32.32 0 0 1-.484.032l-.358-.325a.32.32 0 0 0-.484.032l-.378.48a.418.418 0 0 0 .036.54l1.32 1.267a.32.32 0 0 0 .484-.034l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.88a.32.32 0 0 1-.484.032L1.892 7.77a.366.366 0 0 0-.516.005l-.423.433a.364.364 0 0 0 .006.514l3.255 3.185a.32.32 0 0 0 .484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z" fill="#4fc3f7"/></svg></span-->
                      <span>{{mensaje['canal_entrada.usuario']}}</span>
                    </v-tooltip>
                  </span>
                </div>
              </div>
            </v-card-text>
          </v-card>
          <editor :enviado="this.enviado" :exito="this.exito"
            :opcionesArchivo="opcionesEnvioArchivo"
            :habilitarAudio="habilitarEnvioAudio"
            @archivos="archivosSeleccionados" @mensaje="mensajeEnvio" @enviar="enviarMensaje"></editor>
        </v-flex>
        <v-flex md3 v-if="conectado">
          <!-- <v-btn color="primary"><v-icon>check</v-icon> Crear Caso</v-btn><br> -->
          <v-card>
            <v-card-title class="card-title">
              Persona
            </v-card-title>
            <v-card-text v-if="personaDatos.id">
              <strong>Nombre:</strong> {{personaDatos.nombres}}<br>
              <strong>Apellido(s):</strong> {{personaDatos.primer_apellido}} {{personaDatos.segundo_apellido}}<br>
            </v-card-text>
            <v-card-actions>
              <v-tooltip bottom>
                <v-btn slot="activator" color="warning" @click="verificarDatos()"><v-icon>check</v-icon> Verificar</v-btn>
                <span>Verificar Datos de la Persona</span>
              </v-tooltip>
              <v-spacer></v-spacer>
              <v-tooltip bottom>
                <v-btn icon slot="activator" color="primary" @click.native.stop="verDatosPersona()" v-if="personaDatos && personaDatos.id > 0"><v-icon>remove_red_eye</v-icon></v-btn>
                <span>Ver datos de la Persona</span>
              </v-tooltip>
            </v-card-actions>
          </v-card><br>
          <v-card v-if="caso.id">
            <v-card-title v-if="caso.canal_principal" class="card-title">
              Canales
            </v-card-title>
            <v-card-text v-if="canales_entrada || caso.canal_principal && caso.canal_principal.principal">
              <v-list two-line>
                <v-list-tile
                  v-for="(elem, idc) in canales_entrada"
                  :key="idc"
                  @click="seleccionarPrincipal(elem)"
                >
                  <v-list-tile-content>
                    <v-list-tile-sub-title>
                      <img :src="imagenCanal(elem.clasificacion)" class="icono-canal">
                      {{elem.clasificacion}}
                    </v-list-tile-sub-title>
                    <v-list-tile-title v-if="elem.id !== caso.canal_principal.principal.id">{{formatoUsuario(elem)}}</v-list-tile-title>
                    <v-list-tile-title v-if="elem.id == caso.canal_principal.principal.id"><strong>{{formatoUsuario(elem)}}</strong></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-tooltip bottom color="success">
                      <v-btn
                        icon
                        small
                        outline
                        slot="activator"
                        color="success"
                        v-if="elem.id == caso.canal_principal.principal.id">
                        <v-icon>check</v-icon>
                      </v-btn>
                      <span>{{$t('caso.canal_principal')}}</span>
                    </v-tooltip>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
          <br>
          <v-card>
            <v-card-title v-if="caso.id" class="card-title">
              Caso actual
              <v-btn v-if="caso.id > 0"
                icon
                color="#aaa"
                @click.native.stop="abrirCaso()"
                slot="activator"
                absolute right>
                <v-icon>settings</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text v-if="caso.id">
              {{caso.descripcion}}<br>
              <strong>Tipo</strong> {{ caso.tipo }}<br>
              <strong>Estado</strong> {{ caso.estado }}<br>
            </v-card-text>
            <v-card-actions v-if="caso.estado === 'PENDIENTE' || caso.estado === 'ACTIVO'">
              <v-spacer></v-spacer>
              <v-tooltip bottom>
                <v-btn
                  icon
                  slot="activator"
                  color="primary"
                  @click.native.stop="cambiarEstado('CERRADO')">
                  <v-icon>check</v-icon>
                </v-btn>
                <span>{{$t('caso.cerrar')}}</span>
              </v-tooltip>
              &ensp;
              <v-tooltip bottom>
                <v-btn
                  icon
                  slot="activator"
                  color="primary"
                  :disabled="caso.tipo !== 'COMPLEJO'"
                  @click.native.stop="seleccionarCubiculo()">
                  <v-icon>send</v-icon>
                </v-btn>
                <span>{{$t('caso.derivar')}}</span>
              </v-tooltip>
            </v-card-actions>
          </v-card>
          <br>
          <v-card v-if="casos_adjuntos.length > 0 || casos_pendientes.length > 0 || casos_cerrados.length > 0">
            <v-card-title class="card-title">Historial de casos</v-card-title>
            <v-card-text>
              <v-tooltip bottom v-if="casos_adjuntos.length > 0">
                <v-btn
                  slot="activator"
                  color="success"
                  @click.native.stop="verCasos('Casos Adjuntos', casos_adjuntos, false)">
                  <v-icon color="primary">storage</v-icon>
                  <span>&ensp;<strong>{{casos_adjuntos.length}}</strong> Adjuntos</span>
                </v-btn>
                <span>{{casos_adjuntos.length}} Adjuntos</span>
              </v-tooltip>
              <!--v-tooltip bottom v-if="casos_pendientes.length > 0">
                <v-btn
                  slot="activator"
                  color="success"
                  @click.native.stop="verCasos('Casos Pendientes', casos_pendientes, true)">
                  <v-icon color="primary">alarm_on</v-icon>
                  <span>&ensp;<strong>{{casos_pendientes.length}}</strong> Pendientes</span>
                </v-btn>
                <span>{{casos_pendientes.length}} Pendientes</span>
              </v-tooltip-->
              <v-tooltip bottom v-if="casos_cerrados.length > 0">
                <v-btn
                  slot="activator"
                  color="success"
                  @click.native.stop="verCasos('Casos Cerrados', casos_cerrados, false)">
                  <v-icon color="primary">history</v-icon>
                  <span>&ensp;<strong>{{casos_cerrados.length}}</strong> Cerrados</span>
                </v-btn>
                <span>{{casos_cerrados.length}} Cerrados</span>
              </v-tooltip>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialog" persistent :max-width="700">
        <v-card>
          <v-card-title class="headline">
              <v-icon>{{ verPersona ? 'person' : 'person_add' }}</v-icon> &ensp;{{ verPersona ? $t('chat.ver_persona') : $t('chat.verificacion') }}
            <v-spacer></v-spacer>
            <v-btn small flat icon @click="dialog = false">
              <v-icon class="red--text">cancel</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <persona-datos :key="dialogKey" :id="persona" :opcionesDatos="opcionesDatos" @recuperar="seleccion" :watchOnly="verPersona"></persona-datos>
            <!-- <persona-datos-contrast :key="dialogKey" :id="persona" :opcionesDatos="opcionesDatos" @recuperar="seleccionContraste" :watchOnly="verPersona"></persona-datos-contrast> -->
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" flat @click.native="cancelar">
              <v-icon flat>close</v-icon>
              {{ verPersona ? $t('common.close') : $t('common.cancel') }}
            </v-btn>
            <v-btn color="primary" :disabled="!personaValida" @click.native="guardar" v-if="!verPersona">
              <v-icon>check</v-icon>
              Guardar & Asociar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog :key="dialogCasoKey" v-model="dialogCaso" max-width="700">
        <v-card>
          <v-card-title class="headline m-0">
            <v-flex xs9>
              <v-icon>settings</v-icon> Actualizar Caso
            </v-flex>
            <v-flex xs2 text-md-right>
              <v-chip label color="success" text-color="white" v-if="caso.estado == 'PENDIENTE'">
                {{ caso.estado }}
              </v-chip>
              <v-chip label color="success" text-color="white" v-if="caso.estado == 'ACTIVO'">
                {{ caso.estado }}
              </v-chip>
              <v-chip label color="warning" text-color="white" v-if="caso.estado == 'CERRADO'">
                {{ caso.estado }}
              </v-chip>
              <v-chip label color="danger" text-color="white" v-if="caso.estado == 'CANCELADO'">
                {{ caso.estado }}
              </v-chip>
            </v-flex>
            <v-flex xs1 text-md-right>
              <v-btn small flat icon @click.native="dialogCaso = false">
                <v-icon class="red--text">cancel</v-icon>
              </v-btn>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <caso-modal :id="caso.id" :persona="personaDatos" :canalUsuario="canalUsuario" :cubiculo="cubiculo" @recuperarCaso="recuperarCaso"></caso-modal>
          </v-card-text>
          <v-card-actions>
            <small class="error--text text-required">* {{$t('common.required_fields')}}</small>
            <v-spacer></v-spacer>
            <v-btn flat color="red"
              @click.native="dialogCaso = false">
              <v-icon>close</v-icon> {{$t('common.cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              @click.native="guardarCaso"
              :disabled="!validarCaso">
              <v-icon>check</v-icon> {{$t('common.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog :key="dialogCasosListaKey" v-model="dialogCasosLista" max-width="1000">
        <v-card>
          <v-card-title class="headline m-0">
            <v-flex xs12>
              <v-icon>history</v-icon> {{dialogCasosListaTitulo}}
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs3>
                <v-card v-for="(caso, idx) in casos_lista" :key="idx" v-bind:class="{'success':(caso.id === caso_seleccionado.id)}" @click="seleccionarCaso(caso)">
                  <v-card-text>
                    <strong>Tipo</strong> <span v-text="caso.tipo"></span><br>
                    <strong>Descripción</strong> <span v-text="caso.descripcion"></span>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs9>
                <caso-resumen :key="dialogCasoResumenKey" :caso="caso_seleccionado"></caso-resumen>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click.native="dialogCasosLista = false">
              <v-icon>cancel</v-icon> {{$t('common.cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              @click.native="adjuntarCaso"
              v-if="adjuntar_casos">
              <v-icon>attach_file</v-icon> {{$t('caso.adjuntar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog :key="dialogDerivarKey" v-model="dialogDerivar" max-width="400">
        <v-card>
          <v-card-title class="headline m-0">
            <v-flex xs12>
              <v-icon>send</v-icon> Derivar
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12>
                <v-autocomplete
                  :items="cubiculos"
                  v-model="id_destino"
                  label="Cubículo de destino"
                  item-text="identificador"
                  item-value="id"
                  noDataText="No hay resultados"
                  :rules="$validate(['required'])"
                  required
                  ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click.native="dialogDerivar = false">
              <v-icon>cancel</v-icon> {{$t('common.cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              @click.native="derivarCaso"
              :disabled="!id_destino">
              <v-icon>send</v-icon> {{$t('caso.derivar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </section>
</template>
<script>
import validate from '@/common/mixins/validate';
import token from '@/components/admin/modulo/mixins/token';
import moment from 'moment';
import PersonaDatos from '@/components/admin/persona/PersonaDatos';
import PersonaDatosContrast from '@/components/admin/persona/PersonaDatosContrast';
import CasoModal from './CasoModal';
import CasoResumen from './CasoResumen';
import AudioPlayer from '@/common/plugins/audio/Audio';
import ImagenViewer from '@/common/plugins/imagen/Imagen';
import VideoPlayer from '@/common/plugins/video/Video';
import FileViewer from '@/common/plugins/file/File.vue';
import Editor from '@/common/plugins/editor/Editor.vue';

var socket = require('socket.io-client');
var io = null;
window.onbeforeunload = function (e) {
  io.emit('end');
};
export default {
  props: ['canal', 'cubiculo'],
  mixins: [validate, token],
  created () {
    this.mensajes = [];
    this.user = this.$storage.getUser();
    this.idEntidad = this.user.id_entidad;
    if (this.canal) this.recuperarDatosCanal();
    if (this.idEntidad) this.recuperarTramites();
  },
  beforeDestroy () {
    this.mensajes = [];
    io.emit('end');
  },
  mounted () {
    this.ultimo_mensaje = 0;
    this.mensajes = [];
    this.casos_pendientes = [];
    this.casos_cerrados = [];
    this.casos_adjuntos = [];
    io = socket.connect(process.env.SOCKET_URL, {
      'query': `token=${this.$storage.get('token')}`,
      'path': `${process.env.SOCKET_PATH}`
    });
    io.on('connect', (data) => {

    });
    io.on('error', function (error) {
      if (error.type === 'UnauthorizedError' || error.code === 'invalid_token') {
        // redirect user to login page perhaps?
      }
    });
    io.on('iniciado', (data) => {
      if (this.canal) {
        this.conectado = true;
      }
    });
    io.on('nuevo mensaje', (data) => {
      if (data && data.length > 0) {}
      data.sort((a, b) => {
        if (a.msg_tz && b.msg_tz) {
          return a.msg_tz.substr(0, 10) - b.msg_tz.substr(0, 10);
        }
        return a.id - b.id;
      });

      data.forEach((_item) => {
        let buscar = this.mensajes.find(item => item.id === _item.id);
        if (!buscar) {
          this.mensajes.push(_item);
          if (_item.direccion === 'ENTRADA') {
            io.emit('mensaje leido', _item.id);
          }
          if (this.id_caso !== _item.id_caso) {
            this.id_caso = _item.id_caso;
            this.recuperarCasoActual();
          } else {
            this.id_caso = _item.id_caso;
          }
        } else {
          buscar = _item;
        }
        if (_item.id > this.ultimo_mensaje) this.ultimo_mensaje = _item.id;
      });
      io.emit('ultimo mensaje', {sesion_id: this.canal, ultimo_mensaje: this.ultimo_mensaje, id_entidad: this.idEntidad});
    });
  },
  data () {
    return {
      mensajes: [],
      dialog: false,
      conectado: false,
      canalUsuario: {id: null},
      ultimo_mensaje: 0,
      tramites: [],
      respuestas: [],
      casoForm: {},
      persona: 0,
      dialogKey: 'dialogo',
      personaDatos: { id: 0 },
      id_caso: 0,
      caso: { id: 0, canal_principal: {} },
      dialogCaso: false,
      dialogCasoKey: 'dialogo-caso',
      casos_cerrados: [],
      casos_pendientes: [],
      casos_adjuntos: [],
      canales_entrada: [],
      validarCaso: false,
      tramiteSeleccionado: 0,
      respuestaSeleccionada: '',
      caso_seleccionado: {id: 0},
      enviado: true,
      exito: false,
      archivos: [],
      mensaje: '',
      dialogDerivarKey: 'dialog-derivar',
      dialogDerivar: false,
      cubiculos: [],
      id_destino: null,
      dialogCasosLista: false,
      dialogCasosListaKey: 'dialog-casos-lista-key',
      dialogCasosListaTitulo: 'Casos',
      adjuntar_casos: false,
      casos_lista: [],
      dialogCasoResumenKey: 'dialogCasoResumenKey',
      urlRegex: /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig,
      personaValida: false,
      opcionesDatos: [],
      verPersona: false,
      flagOpcionesEnvio: false,
      opcionesEnvioArchivo: [],
      habilitarEnvioAudio: true
    };
  },
  watch: {
    'canalUsuario.id_persona': function () {
      // this.recuperarCasosCerrados();
      // this.recuperarCasosPendientes();
    },
    'personaDatos.id' () {

    },
    canal () {
      // this.recuperarCasosCerrados();
      // this.recuperarCasosPendientes();
    },
    id_caso () {
      this.flagOpcionesEnvio = !this.flagOpcionesEnvio;
      // this.recuperarCasoActual();
      // this.recuperarCasosCerrados();
      // this.recuperarCasosPendientes();
    },
    'caso.id': function () {
      this.flagOpcionesEnvio = !this.flagOpcionesEnvio;
      // this.recuperarCasosCerrados();
      // this.recuperarCasosPendientes();
    },
    'mensajes' () {
      // if (this.mensajes.length > 0 && !this.caso ) {
      //  this.recuperarCasosCerrados();
      //  this.recuperarCasosPendientes();
      //  this.guardarCaso();
      // }
    },
    tramiteSeleccionado () {
      this.recuperarRespuestas();
    },
    respuestaSeleccionada () {
      this.mensaje = this.respuestaSeleccionada;
    },
    flagOpcionesEnvio () {
      if (this.caso && this.caso.canal_principal && this.caso.canal_principal.principal && this.caso.canal_principal.principal.clasificacion) {
        // if (this.caso.canal_principal.principal.clasificacion === 'twitter') {
        //   this.opcionesEnvioArchivo = ['jpg', 'jpeg', 'png'];
        //   this.habilitarEnvioAudio = false;
        // } else if (this.caso.canal_principal.principal.clasificacion === 'facebook') {
        //   this.opcionesEnvioArchivo = [];
        //   this.habilitarEnvioAudio = false;
        // } else {
        //   this.opcionesEnvioArchivo = [];
        //   this.habilitarEnvioAudio = true;
        // }
        this.$service.get(`system/canales/opciones_editor/${this.caso.canal_principal.principal.clasificacion}`, {})
        .then(response => {
          if (response) {
            this.opcionesEnvioArchivo = response.formatosArchivo || [];
            this.habilitarEnvioAudio = response.enviarAudio || false;
          } else {
            this.opcionesEnvioArchivo = [];
            this.habilitarEnvioAudio = true;
          }
        });
      }
    }
  },
  methods: {
    imagenCanal (clasificacion) {
      let imagen = 'call.png';
      switch (clasificacion) {
        case 'whatsapp':
          imagen = 'wp.png';
          break;
        case 'facebook':
          imagen = 'fb.png';
          break;
        case 'twitter':
          imagen = 'tw.png';
          break;
        case 'correo':
          imagen = 'mail.png';
          break;
      }
      return require('@/assets/images/' + imagen);
    },
    formatoUsuario (usuario) {
      if (usuario.clasificacion === 'whatsapp') {
        return usuario.usuario.split('@')[0];
      }
      return usuario.usuario;
    },
    seleccionarCaso (caso) {
      this.caso_seleccionado = caso;
      this.dialogCasoResumenKey = 'dialogCasoResumenKey' + Math.random().toString(36).substr(2, 5);
    },
    seleccion (value) {
      this.personaDatos = value;
      if (value && value.fecha_nacimiento && value.tipo_documento && value.nro_documento && value.nombres && value.primer_apellido && value.genero) {
        this.personaValida = true;
      } else {
        this.personaValida = false;
      }
    },
    seleccionContraste (value) {
      this.personaDatos = value;
      if (value && value.fecha_nacimiento && value.tipo_documento && value.nro_documento && value.nombres && value.primer_apellido && value.genero && value.contrastado) {
        this.personaValida = true;
      } else {
        this.personaValida = false;
      }
    },
    archivosSeleccionados (value) {
      this.archivos = value;
    },
    mensajeEnvio (value) {
      this.mensaje = value;
    },
    enviarMensaje (value) {
      this.exito = false;
      if (value === 'mensaje') {
        this.enviado = false;
        this.$loading.show('Enviando mensaje...');
        this.loading = true;
        this.$service.post(`system/operadores/enviar/mensaje/${this.canal}`, { caso: this.caso.id, cubiculo: this.cubiculo, contenido: this.mensaje, tipo_contenido: 'texto', direccion: 'SALIDA' })
        .then(response => {
          this.loading = false;
          if (response) {
            this.$message.success(`Enviado exitosamente!`, null, { timeout: 2000 });
            this.mensaje = '';
            this.enviado = true;
            this.exito = true;
          } else {
            this.$message.error(`No se pudo enviar el mensaje!`, null, { timeout: 2000 });
            this.enviado = true;
          }
        });
      }
      if (value === 'archivos') {
        this.$confirm(`¿Está seguro de enviar archivos?`, () => {
          this.enviado = false;
          this.$loading.show('Enviando documentos...');
          this.loading = true;
          this.$service.post(`system/operadores/enviar/mensaje/${this.canal}`, { caso: this.caso.id, cubiculo: this.cubiculo, contenido: this.archivos, tipo_contenido: 'archivo', direccion: 'SALIDA' })
          .then(response => {
            this.loading = false;
            if (response) {
              this.$message.success(`Enviado exitosamente!`, null, { timeout: 2000 });
              this.mensaje = '';
              this.enviado = true;
              this.exito = true;
            } else {
              this.$message.error(`No se pudo enviar el mensaje!`, null, { timeout: 2000 });
              this.enviado = true;
            }
          });
        });
      }
    },
    verificarDatos (data = {}) {
      this.recuperarOpcionesDatos();
      this.dialogKey = 'dialog' + Math.random().toString(36).substr(2, 5);
      this.persona = this.canalUsuario.id_persona;
      this.dialog = true;
      this.verPersona = false;
    },
    recuperarOpcionesDatos () {
      if (this.idEntidad) {
        this.opcionesDatos = [];
        this.$service.get(`system/entidades/tipos_dato/${this.idEntidad}`, {})
        .then(response => {
          if (response) {
            this.opcionesDatos = response.datos_usuario;
          }
        });
      }
    },
    formato (mensaje) {
      if (mensaje.msg_tz) {
        let fecha = mensaje.msg_tz.substr(0, 10) * 1000;
        var date = moment(fecha).format('DD/MM/YYYY HH:mm:ss');
        return date;
      } else {
        return moment(mensaje._created_at).format('DD/MM/YYYY HH:mm:ss');
      }
    },
    recuperarCasos () {
      if (this.canalUsuario.id_persona) {
        // this.recuperarCasosCerrados();
        this.recuperarCasosPendientes();
        this.recuperarCanalesPersona();
        // this.guardarCaso();
      } else {
        this.casos_cerrados = [];
        this.casos_pendientes = [];
        this.casos_adjuntos = [];
      }
    },
    verCasos (titulo, casos, adjuntar) {
      this.adjuntar_casos = adjuntar;
      this.dialogCasosListaTitulo = titulo;
      this.casos_lista = casos;
      if (casos.length > 0) {
        this.caso_seleccionado = casos[0];
        this.dialogCasoResumenKey = 'dialogCasoResumenKey' + Math.random().toString(36).substr(2, 5);
      }
      this.dialogCasosLista = true;
    },
    adjuntarCaso () {
      this.$confirm(`¿Está seguro de adjuntar al caso seleccionado?<br>Se marcará el caso actual como CERRADO.`, () => {
        this.$loading.show('Adjuntando caso actual');
        this.loading = true;
        this.$service.put(`system/operadores/caso/adjuntar/${this.caso.id}`, { caso: this.caso, caso_destino: this.caso_seleccionado })
        .then(response => {
          if (response) {
            this.caso = response;
            this.$message.success(`Caso adjuntado exitosamente!`, null, { timeout: 2000 });
            this.dialogCasosLista = false;
            this.recuperarCasosCerrados();
            this.$emit('adjuntado', this.caso);
          }
        });
      });
    },
    recuperarTramites () {
      if (this.idEntidad) {
        this.tramites = [];
        this.$service.get(`system/tramites`, {})
        .then(response => {
          if (response) {
            this.tramites = response.rows;
          }
        });
      }
    },
    recuperarRespuestas () {
      if (this.tramiteSeleccionado) {
        this.respuestas = [];
        this.$service.get(`system/faqs/tramite/${this.tramiteSeleccionado}`, {})
        .then(response => {
          if (response) {
            response.rows.forEach((item) => {
              this.respuestas.push(item.respuesta);
            });
          }
        });
      }
    },
    recuperarDatosCanal () {
      if (this.canal) {
        this.$service.get(`system/operadores/canal/${this.canal}`, {})
        .then(response => {
          if (response) {
            this.canalUsuario = response;
            this.mensajes = [];
            this.mensaje = '';
            this.ultimo_mensaje = 0;
            if (this.canalUsuario.id_persona > 0) {
              this.recuperarPersona();
            }
            io.emit('iniciar', {id: this.cubiculo, sesion_id: this.canal});
          }
        });
      }
    },
    recuperarCasoActual () {
      if (this.id_caso) {
        this.$loading.show('Recuperando caso actual...');
        this.loading = true;
        this.$service.get(`system/operadores/caso/${this.id_caso}`, {})
        .then(response => {
          if (response) {
            this.caso = response;
            this.canales_entrada = this.caso.canales;
            this.recuperarCasos();
            this.loading = false;
          }
        });
      }
    },
    recuperarPersona () {
      this.$loading.show('Buscando persona');
      this.loading = true;
      let url = `system/operadores/persona/${this.canalUsuario.id_persona}`;
      this.$service.get(url)
      .then(response => {
        this.loading = false;
        if (response) {
          this.personaDatos = response;
        }
        // this.recuperarCasosCerrados();
        // this.recuperarCasos();
      });
    },
    cancelar () {
      this.dialog = false;
    },
    guardar () {
      this.$loading.show('Asociando a Persona');
      this.loading = true;
      this.$service.put(`system/operadores/asociar/persona/${this.canal}`, { persona: this.personaDatos })
      .then(response => {
        if (response) {
          this.$message.success(`Asociado exitosamente!`, null, { timeout: 2000 });
          if (response.persona) {
            this.personaDatos = response.persona.data;
          }
          this.canalUsuario.id_persona = this.personaDatos.id;
          this.dialog = false;
          this.$emit('recuperar', this.personaDatos);

          if (this.personaDatos.id !== this.caso.id_persona) {
            this.caso.id_persona = this.personaDatos.id;
            this.guardarCaso();
          }
          this.recuperarCasos();
        }
      });
    },
    recuperarCaso (val = {}) {
      if (val && val.id_tramite && val.tipo && val.descripcion && val.descripcion.length > 0) {
        this.caso.tipo = val.tipo;
        this.caso.descripcion = val.descripcion;
        this.caso.id_tramite = val.id_tramite;
        this.caso.id_persona = this.personaDatos.id;
        this.validarCaso = true;
      } else {
        this.validarCaso = false;
      }
    },
    recuperarCasosCerrados () {
      if (this.canalUsuario.id_persona) {
        // this.$loading.show('Buscando casos cerrados...');
        this.loading = false;
        let url = `system/operadores/casos/${this.canalUsuario.id_persona}?estado=CERRADO`;
        this.$service.get(url)
        .then(response => {
          this.loading = false;
          if (response && response.rows) {
            this.casos_cerrados = [];
            response.rows.forEach((item) => {
              if (item.id !== this.id_caso) {
                this.casos_cerrados.push(item);
              }
            });
            this.recuperarCasosAdjuntos();
          }
        });
      }
    },
    recuperarCanalesPersona () {
      if (this.canalUsuario.id_persona) {
        // this.$loading.show('Buscando casos pendientes...');
        this.loading = false;
        let url = `system/operadores/canales/${this.canalUsuario.id_persona}`;
        this.$service.get(url)
        .then(response => {
          this.loading = false;
          this.canales_entrada = response.rows || [];
        });
      } else {
        this.canales_entrada = this.caso.canales;
      }
    },
    recuperarCasosPendientes () {
      if (this.canalUsuario.id_persona) {
        // this.$loading.show('Buscando casos pendientes...');
        this.loading = false;
        let url = `system/operadores/casos/${this.canalUsuario.id_persona}?estado=PENDIENTE`;
        this.$service.get(url)
        .then(response => {
          this.loading = false;
          this.casos_pendientes = [];
          if (response && response.rows) {
            response.rows.forEach((item) => {
              this.casos_pendientes.push(item);
            });
          }
          if (this.casos_pendientes.length > 1) {
            this.verCasos('Casos Pendientes', this.casos_pendientes, true);
          }
          this.recuperarCasosCerrados();
        });
      }
    },
    recuperarCasosAdjuntos () {
      if (this.canalUsuario.id_persona) {
        // this.$loading.show('Buscando casos adjuntos...');
        this.loading = false;
        let url = `system/operadores/casos/${this.caso.id}/adjuntos`;
        this.$service.get(url)
        .then(response => {
          this.loading = false;
          this.casos_adjuntos = [];
          if (response && response.rows) {
            response.rows.forEach((item) => {
              this.casos_adjuntos.push(item);
            });
          }
        });
      }
    },
    guardarCaso () {
      if (this.caso.id === 0) {
        delete this.caso.id;
      }
      this.$loading.show('Asociando caso');
      this.loading = true;
      this.$service.put(`system/operadores/caso/guardar/${this.caso.id}`, { caso: this.caso })
      .then(response => {
        if (response) {
          this.caso = response;
          this.$message.success(`Caso guardado exitosamente!`, null, { timeout: 2000 });
          this.dialogCaso = false;
          this.recuperarCasos();
        }
      });
    },
    abrirCaso () {
      this.dialogCasoKey = 'dialogCasoKey' + Math.random().toString(36).substr(2, 5);
      this.dialogCaso = true;
    },
    cambiarEstado (estado) {
      this.$confirm(`¿Está seguro de cambiar el estado a ${estado}?`, () => {
        this.$loading.show(`Cambiando el estado del caso a ${estado}`);
        this.loading = true;
        this.$service.put(`system/operadores/caso/estado/${this.caso.id}`, { caso: {estado: estado} })
        .then(response => {
          if (response) {
            this.caso = response;
            this.recuperarCasos();
            this.$message.success(`El caso cambió de estado a ${estado} exitosamente!`, null, { timeout: 2000 });
            if (estado === 'CERRADO') {
              this.$emit('adjuntado', this.caso);
            }
          }
        });
      });
    },
    seleccionarCubiculo () {
      this.recuperarCubiculos();
      this.dialogDerivarKey = 'dialogDerivarKey' + Math.random().toString(36).substr(2, 5);
      this.dialogDerivar = true;
    },
    recuperarCubiculos () {
      if (this.idEntidad) {
        this.cubiculos = [];
        this.$service.get(`system/puntos`, {})
        .then(response => {
          if (response && response.rows) {
            response.rows.forEach((item) => {
              if (item.id !== this.cubiculo) {
                this.cubiculos.push(item);
              }
            });
          }
        });
      }
    },
    derivarCaso () {
      if (this.caso && this.caso.id && this.id_destino) {
        this.$confirm(`¿Está seguro de derivar el caso a otro Punto de Atención?`, () => {
          this.$loading.show('Derivando caso');
          // this.loading = true;
          let derivar = {
            id_caso: this.caso.id,
            id_destino: this.id_destino
          };
          this.$service.put(`system/casos/derivar`, derivar)
          .then(response => {
            if (response) {
              this.$message.success(`Caso derivado exitosamente!`, null, { timeout: 2000 });
              this.dialogDerivar = false;
              this.$emit('derivar', this.canal);
            }
          });
        });
      } else {
        this.$message.error(`Debe seleccionar el punto de atención al que se derivará el caso!`, null, { timeout: 2000 });
      }
    },
    parsearContenido (contenido) {
      return contenido.replace(this.urlRegex, function (url) {
        return '<a href="' + url + '" target="_blank">' + url + '</a>';
      });
    },
    verDatosPersona () {
      if (this.personaDatos && this.personaDatos.id) {
        // this.dialogDatosPersonaKey = 'dialogDatosPersonaKey' + Math.random().toString(36).substr(2, 5);
        // this.dialogDatosPersona = true;
        this.recuperarOpcionesDatos();
        this.dialogKey = 'dialog' + Math.random().toString(36).substr(2, 5);
        this.persona = this.canalUsuario.id_persona;
        this.dialog = true;
        this.verPersona = true;
      } else {
        this.$message.warning(`No se ha verificado a la persona en esta conversación`, null, { timeout: 2000 });
      }
    },
    seleccionarPrincipal (canal) {
      this.$confirm(`¿Está seguro de cambiar el canal principal de este caso?`, () => {
        this.$loading.show('Aplicando el cambio de canal...');
        this.loading = true;
        this.$service.put(`system/casos/cambiar/canal_principal/${this.caso.id}`, { canal: canal })
        .then(response => {
          this.loading = false;
          if (response) {
            this.caso = response;
            this.flagOpcionesEnvio = !this.flagOpcionesEnvio;
            this.$message.success(`Canal principal actualizado exitosamente!`, null, { timeout: 2000 });
          } else {
            this.$message.error(`No se pudo actualizar el canal principal!`, null, { timeout: 2000 });
          }
        });
      });
    }
  },
  updated () {
    var container = this.$el.querySelector('#conversation');
    container.scrollTop = container.scrollHeight;
  },
  components: {socket, moment, PersonaDatos, PersonaDatosContrast, CasoModal, CasoResumen, AudioPlayer, ImagenViewer, VideoPlayer, FileViewer, Editor}
};
</script>
<style src="./chat.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/admin/operadores/ChatUsuario.vue